const {InnerBlocks, useInnerBlocksProps, useBlockProps} = wp.blockEditor;

export default function save(props) {
	return <InnerBlocks.Content/>;
}